import React, { useState } from "react";
import PropTypes from 'prop-types';
import Colors from '../assets/color';
import { TextField, Button, Box, Alert } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';

function Waitlist() {
  const [email, setEmail] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isEmailValid = function (emailAdress) {
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return emailAdress.match(regex);
  }


  const waitlistSubmitHandler = async () => {
    const url = 'https://api.sender.net/v2/subscribers';
    const token =
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiYjVjNDY5ZTFjNjc1ZTViZTU2YzdjYTNhOTE0ZjcxNTZmYjY4Y2NkNjA5ZGI3ZDk4OWIzMjMyODAxYmM2MTU3NjkxOTA0Y2E0YWQ2ZTAzMWYiLCJpYXQiOiIxNzM0NzgwNzU2LjcwMzE0NiIsIm5iZiI6IjE3MzQ3ODA3NTYuNzAzMTQ4IiwiZXhwIjoiNDg4ODM4MDc1Ni43MDE3NDciLCJzdWIiOiI5MzkxOTIiLCJzY29wZXMiOltdfQ.hctMvd1miu-Teyi8EXM8hcDbW8ANdTwhRvLe_yYsBsN0vYlYARvRMkp8wNxpWhRCEkrN7cIMXoX7RWnAJqFL8Q';
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const data = {
      email,
      grouups: ['aOLJYB'],
      "trigger_automation": false,
    };

    try {
      setIsSubmitting(true)
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.success === true) {
        setMessage('Email submitted successfully!');
        setSeverity('success');
        setIsSubmitting(false)

        setEmail("");
        return setIsOpen(true);
      }

      setMessage('Failed to submit email. Please try again.');
      setSeverity('error');
      setIsSubmitting(false)
      setIsOpen(true);

    } catch (error) {
      setMessage('An error occurred. Please try again.');
      setSeverity('error');
      setIsSubmitting(false)

      setIsOpen(true);
    }
  };

  return (

    <Box
      component="form"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: "16px",
        margin: "1.6rem 0",
      }}
    >
      <TextField
        required
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '25px',
            background: Colors.white, height: '51px',
          },
          '& .MuiInputBase-input::placeholder': {
            color: '#5F6368',
          },
          "& .MuiOutlinedInput-input": {
            padding: '28px',
            fontSize: '16px',
            fontFamily: 'mulish',
            color: '#5F6368',
          },
          width: { xs: "335px", sm: "344px" },
        }}
      />

      <Button
        onClick={() => {
          if (!email) {
            setMessage('Please enter Your Email Address!');
            setSeverity('warning');

            return setIsOpen(true);
          }

          if (!isEmailValid(email)) {
            setMessage('Please enter valid email address!');
            setSeverity('warning');

            return setIsOpen(true);
          }

          waitlistSubmitHandler();
        }}

        sx={{
          backgroundColor: "primary.main",
          height: "4.8rem",
          borderRadius: "25px",
          color: "black",
          fontSize: "1.8rem",
          fontWeight: 700,
          textTransform: "none",
          p: '1.2rem 2.4rem',
        }}
      >
        {isSubmitting ? 'Submitting...' : 'Join the waitlist'}
      </Button>

      <Snackbar
        open={isOpen}
        autoHideDuration={2000}
        onClose={() => setIsOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setIsOpen(false)}
          severity={severity}
          variant="filled"
          sx={{ width: '100%', fontSize: '1.4rem' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>

  );
}

Waitlist.propTypes = {
  window: PropTypes.func,
};

export default Waitlist;